import * as selector from "./selector";
import { Headers } from "./header";

const apiUrl = process.env.REACT_APP_API_URL;

const auth = `${apiUrl}/auth/api`;
const config = `${apiUrl}/config/api`;
const app = `${apiUrl}/app/api`;
const gateway = `${apiUrl}/gateway/api`;
const image = `${apiUrl}/`;

export { auth, config, app, gateway, image, selector, Headers };
